import { ClubItemLoading, MyClubItemLoading } from '@/components/skeleton'
import { ROUTE_MY_CLUBS } from '@/constants/Routes'
import { ClubItem, MyClubItem } from '@/pages/club/components'
import { Club, MyClub } from '@/types'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useMediaQuery } from 'usehooks-ts'

type Props = {
  isLoadingClubs?: boolean
  isLoadingMyClubs?: boolean
  myClubs?: MyClub[]
  clubs?: Map<number, Club>
  hasMore?: boolean
  setLastElement?: any
}

export const ClubContent = ({ isLoadingClubs, isLoadingMyClubs, myClubs, clubs, hasMore, setLastElement }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const mobileL = useMediaQuery('(max-width: 425px)')
  const mobileM = useMediaQuery('(max-width: 375px)')

  const onNavigateMyClub = () => {
    navigate(ROUTE_MY_CLUBS)
  }

  const renderMyClubs = () => {
    if (isLoadingMyClubs && mobileL && mobileM)
      return (
        <>
          <MyClubItemLoading />
          <MyClubItemLoading />
        </>
      )

    if (isLoadingMyClubs && mobileL && !mobileM)
      return (
        <>
          <MyClubItemLoading />
          <MyClubItemLoading />
          <MyClubItemLoading />
        </>
      )

    if (isLoadingMyClubs && !mobileL && !mobileM)
      return (
        <>
          <MyClubItemLoading />
          <MyClubItemLoading />
          <MyClubItemLoading />
          <MyClubItemLoading />
        </>
      )
    if (myClubs?.length && mobileL && mobileM)
      return myClubs?.slice(0, 2).map((item) => <MyClubItem key={item.clubId} club={item} />)

    if (myClubs?.length && mobileL && !mobileM)
      return myClubs?.slice(0, 3).map((item) => <MyClubItem key={item.clubId} club={item} />)

    if (myClubs?.length && !mobileL && !mobileM)
      return myClubs?.slice(0, 4).map((item) => <MyClubItem key={item.clubId} club={item} />)

    return <></>
  }

  return (
    <div className="mt-8">
      {myClubs && myClubs?.length > 0 && (
        <div className="flex flex-col gap-y-4">
          <div className="flex items-center justify-between">
            <h3 className="text-xl font-semibold text-white">{t('club.myClubs')}</h3>
            <button className="text-white font-semibold text-sm hover:text-opacity-70" onClick={onNavigateMyClub}>
              {t('common.viewAll')}
            </button>
          </div>
          <div className={`flex gap-x-2 flex-wrap`}>{renderMyClubs()}</div>
        </div>
      )}

      <div className="mt-4">
        <h2 className="text-white font-semibold text-xl">{t('club.exploreClubs')}</h2>
        <div className="flex flex-col md:flex-row gap-y-2 md:flex-wrap md:gap-2 mt-3">
          {clubs &&
            Array.from(clubs?.values())?.map((item, index) => (
              <div key={item.clubId} ref={index === clubs?.size - 1 && hasMore ? setLastElement : null}>
                <ClubItem club={item} />
              </div>
            ))}
          {isLoadingClubs && (
            <>
              <ClubItemLoading />
              <ClubItemLoading />
              <ClubItemLoading />
              <ClubItemLoading />
              <ClubItemLoading />
              <ClubItemLoading />
              <ClubItemLoading />
              <ClubItemLoading />
              <ClubItemLoading />
            </>
          )}
        </div>
        {!hasMore && (
          <div className="flex justify-center mt-3">
            <span className="text-white font-semibold text-opacity-60">{t('common.noMoreResults')}</span>
          </div>
        )}
      </div>
    </div>
  )
}
